module.exports = __webpack_public_path__ + "static/toyota-70b9d3fc0fd0763a8bc713abb6599884.png";